module.exports = __webpack_public_path__ + "static/media/pod_pass.96314b3e.svg";